/* eslint-disable react/prop-types */
import React from 'react';

export const PRODUCTIVITY_SUMMARY_BADGE_CONFIG = [
  { key: 'totalWelds', label: 'Total welds', tone: 'total' },
  { key: 'acceptedCounts', label: 'Accepted', tone: 'accepted' },
  { key: 'rejectedCutout', label: 'Cutout', tone: 'cutout' },
  { key: 'rejectedRepair', label: 'Repair', tone: 'repair' },
];

const ProductivitySummaryBadges = ({
  summary,
  isLoading = false,
  className = '',
}) => (
  <div
    className={`dpr-productivity-chips ${className}`.trim()}
    aria-label="Productivity summary"
  >
    {PRODUCTIVITY_SUMMARY_BADGE_CONFIG.map(({ key, label, tone }) => {
      const value = summary?.[key];
      const displayValue = isLoading ? '—' : (value != null ? String(value) : '0');
      return (
        <span
          key={key}
          className={`dpr-productivity-chip dpr-productivity-chip--${tone}`}
          title={label}
        >
          <span className="dpr-productivity-chip__label">{label}</span>
          <span className="dpr-productivity-chip__value">{displayValue}</span>
        </span>
      );
    })}
  </div>
);

export default ProductivitySummaryBadges;
